module.exports = __webpack_public_path__ + "img/ax_main.76cbac26.svg";